import React from "react";

function Footer() {
  return (
    <footer className="bg-white/70 backdrop-blur-md text-brand-red text-center py-16 border-t border-gray-200 mt-20 transition-all duration-500">
      <h3 className="text-3xl font-bold mb-8 animate-fadeIn">Visit Us</h3>

      {/* Business Name */}
      <p className="text-lg mb-2 font-semibold">Texana Trading Co.</p>

      {/* Address */}
      <p className="text-lg mb-2">
        <a
          href="https://www.google.com/maps/place/421+Andrews+Hwy,+Midland,+TX+79701"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline hover:text-red-800 transition-colors duration-300"
        >
          421 Andrews Hwy, Midland, TX 79701
        </a>
      </p>

      {/* Contact Info */}
      <p className="text-lg mb-6">
        📞{" "}
        <a
          href="tel:+14326873400"
          className="hover:underline hover:text-red-800 transition-colors duration-300"
        >
          (432) 687-3400
        </a>{" "}
        | ✉️{" "}
        <a
          href="mailto:info@texanatrading.com"
          className="hover:underline hover:text-red-800 transition-colors duration-300"
        >
          info@texanatrading.com
        </a>
      </p>

      {/* Hours + Location */}
      <div className="flex flex-col md:flex-row justify-center gap-12 text-lg font-medium">
        {/* Hours */}
        <div>
          <h4 className="text-xl font-semibold mb-2 underline underline-offset-4">
            Hours of Operation
          </h4>
          <ul>
            <li>Monday – Saturday: 10:00 AM – 6:00 PM</li>
            <li>Sunday: Closed</li>
          </ul>
        </div>

        {/* Map Embed */}
        <div>
          <h4 className="text-xl font-semibold mb-2 underline underline-offset-4">
            Location
          </h4>
          <iframe
            title="Texana Trading Co. Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3422.609981157969!2d-102.0968!3d31.9975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86fe2c030e4a6f07%3A0x9d5c70a32f7c3e9b!2s421%20Andrews%20Hwy%2C%20Midland%2C%20TX%2079701!5e0!3m2!1sen!2sus!4v1696240000000!5m2!1sen!2sus"
            width="100%"
            height="250"
            style={{ border: "0", borderRadius: "12px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="shadow-md border border-brand-red mx-auto md:mx-0"
          ></iframe>
        </div>
      </div>

      {/* Copyright */}
      <p className="mt-10 text-sm opacity-80">
        © {new Date().getFullYear()} Texana Trading Co. | All Rights Reserved
      </p>
    </footer>
  );
}

export default Footer;